import { contentAdminAxios, requireData, requireSuccess, type ApiEnvelope } from '../../common/api/client'
import type { AssignedEntityTaxonomy, EntityTaxonomyAssignment, TaxonomyGroup, TaxonomyTerm } from '../types'

export const taxonomiesApi = {
  async listTaxonomies(entityType?: string) {
    const params = entityType ? { entity_type: entityType } : {}
    const response = await contentAdminAxios.get<ApiEnvelope<TaxonomyGroup[]>>('/taxonomies', { params })
    return requireData(response.data, 'Không thể tải danh sách taxonomies')
  },

  async createTaxonomy(payload: { code: string; name: string; description?: string; translations?: Record<string, any>; entity_types?: string[] }) {
    const response = await contentAdminAxios.post<ApiEnvelope<TaxonomyGroup>>('/taxonomies', payload)
    return requireData(response.data, 'Không thể tạo taxonomy group mới')
  },

  async updateTaxonomy(id: string, payload: { name?: string; description?: string; translations?: Record<string, any>; entity_types?: string[] }) {
    const response = await contentAdminAxios.patch<ApiEnvelope<TaxonomyGroup>>(`/taxonomies/${id}`, payload)
    return requireData(response.data, 'Không thể cập nhật taxonomy group')
  },

  async removeTaxonomy(id: string) {
    const response = await contentAdminAxios.delete<ApiEnvelope<unknown>>(`/taxonomies/${id}`)
    requireSuccess(response.data, 'Không thể xóa taxonomy group')
  },

  async createTerm(taxonomyId: string, payload: { code: string; name: string; description?: string; translations?: Record<string, any>; parent_id?: string; sort_order?: number }) {
    const response = await contentAdminAxios.post<ApiEnvelope<TaxonomyTerm>>(`/taxonomies/${taxonomyId}/terms`, payload)
    return requireData(response.data, 'Không thể tạo taxonomy term mới')
  },

  async updateTerm(termId: string, payload: { name?: string; description?: string; translations?: Record<string, any>; parent_id?: string; sort_order?: number }) {
    const response = await contentAdminAxios.patch<ApiEnvelope<TaxonomyTerm>>(`/taxonomy-terms/${termId}`, payload)
    return requireData(response.data, 'Không thể cập nhật taxonomy term')
  },

  async removeTerm(termId: string) {
    const response = await contentAdminAxios.delete<ApiEnvelope<unknown>>(`/taxonomy-terms/${termId}`)
    requireSuccess(response.data, 'Không thể xóa taxonomy term')
  },

  async getEntityTaxonomies(entityType: string, entityId: string) {
    const response = await contentAdminAxios.get<ApiEnvelope<EntityTaxonomyAssignment>>(`/entity-taxonomies/${entityType}/${entityId}`)
    return requireData(response.data, 'Không thể tải taxonomy của đối tượng')
  },

  async replaceEntityTaxonomies(entityType: string, entityId: string, taxonomyTermIds: string[]) {
    const response = await contentAdminAxios.put<ApiEnvelope<EntityTaxonomyAssignment>>(`/entity-taxonomies/${entityType}/${entityId}`, { taxonomy_term_ids: taxonomyTermIds })
    return requireData(response.data, 'Không thể cập nhật taxonomy cho đối tượng')
  },
}
